// extracted by mini-css-extract-plugin
export default {"Emoji":"bbr_a bht_i bht_q bht_j"};